
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetoashtavinayakcabs() {



    const cardData =
    {
        keyword: ' Pune to Ashtavinayak Cab',
        heading: 'Prince Cabs: Pune to Ashtavinayak Cab',
        headingDescription: 'Prince Cabs offers trusted Pune to Ashtavinayak Cab services, specially designed for devotees and travelers visiting the sacred Ashtavinayak Ganpati temples. Our well-maintained sedans, SUVs, and luxury vehicles provide a safe, comfortable, and convenient ride across all eight temple locations. With professional chauffeurs, customizable travel plans, and on-time service, we make your spiritual journey smooth and hassle-free. Choose Prince Cabs’ Pune to Ashtavinayak taxi service for affordable fares, flexible schedules, and a peaceful travel experience throughout your pilgrimage.',

        top: 'Top Places to Visit in Ashtavinayak with Prince Cabs',

"topPlaces": [
  {
    "title": "Mayureshwar Temple, Morgaon",
    "description": "Located in Morgaon, the Mayureshwar Temple is the first and most important shrine in the Ashtavinayak circuit. Dedicated to Lord Ganesha, the temple is believed to have been built in the 14th century and is known for its beautiful architecture and sacred significance. Surrounded by four gates symbolizing the four directions, it reflects the universality of Ganesha. Legend states that Ganesha defeated the demon Sindhu here, riding a peacock, hence the name Mayureshwar. Pilgrims begin their Ashtavinayak yatra from this temple. Its serene setting makes it spiritually uplifting."
  },
  {
    "title": "Siddhivinayak Temple, Siddhatek",
    "description": "Situated on the banks of the Bhima River, Siddhatek houses the Siddhivinayak Temple, famous for fulfilling the wishes of devotees. The temple is surrounded by scenic hills and requires a climb of nearly 400 steps, making the journey both spiritual and physical. It is believed that Lord Vishnu obtained Siddhi (power) here by worshipping Lord Ganesha. The idol is unique, with the trunk turned to the right, which is considered very auspicious. The tranquil environment enhances the divine experience. It is a must-visit stop in the Ashtavinayak pilgrimage."
  },
  {
    "title": "Ballaleshwar Temple, Pali",
    "description": "Ballaleshwar Temple in Pali is the only Ashtavinayak shrine named after a devotee, Ballal, highlighting Ganesha’s compassion. The temple is known for its striking wooden architecture and scenic surroundings. During sunrise, the temple is illuminated in golden light, making it a visually enchanting experience. It is said that Lord Ganesha appeared before Ballal here and blessed him eternally. The idol, dressed in silver, faces east and shines beautifully under the morning sun. This temple emphasizes devotion and faith as the path to divine blessings."
  },
  {
    "title": "Varadvinayak Temple, Mahad",
    "description": "Located in Mahad near Karjat, the Varadvinayak Temple is famous for granting boons and wishes. Unlike most temples, devotees are allowed to directly touch and perform rituals on the idol. The temple is surrounded by a serene pond and lush greenery. Its simple yet powerful atmosphere draws pilgrims throughout the year. The temple’s architecture reflects old stone carvings with a calm rustic charm. Locals believe that the temple’s lamp has been burning continuously since it was first lit centuries ago. It represents Ganesha as the giver of prosperity and fulfillment."
  },
  {
    "title": "Chintamani Temple, Theur",
    "description": "The Chintamani Temple in Theur is associated with the legend of Lord Ganesha retrieving the precious Chintamani jewel and returning it to Sage Kapila. The temple is situated along the Mula River and is one of the most popular Ashtavinayak shrines. The idol, adorned with diamonds, represents peace of mind and fulfillment of desires. The temple’s spacious courtyards and spiritual atmosphere attract thousands of devotees, especially during festivals. Historically, it was patronized by the Peshwas, who frequently visited for blessings. It remains a significant center of Ganesha worship."
  },
  {
    "title": "Girijatmaj Temple, Lenyadri",
    "description": "The Girijatmaj Temple in Lenyadri is unique as it is carved into a mountain cave, requiring a climb of over 300 steps. Dedicated to Ganesha as the son of Goddess Parvati, this is the only Ashtavinayak temple located in a cave. The natural rock-cut structure, with 18 rock-cut rooms surrounding the main shrine, fascinates history buffs and devotees alike. The serene valley views from the temple make the climb worthwhile. The temple symbolizes meditation, austerity, and spiritual awakening. It is a rare blend of mythology, history, and natural beauty."
  },
  {
    "title": "Vighneshwar Temple, Ozar",
    "description": "The Vighneshwar Temple at Ozar represents Lord Ganesha as the remover of obstacles (Vighnaharta). Built along the Kukadi River, the temple features beautiful white walls, shikhara (spire), and intricate carvings. The idol is adorned with jewels and diamonds, radiating divine energy. The temple is also historically significant as it was fortified during the reign of Chimaji Appa. Festivals like Ganesh Chaturthi are celebrated with grandeur here. Its spiritual aura, coupled with natural beauty, makes it a powerful stop in the Ashtavinayak yatra."
  },
  {
    "title": "Mahaganapati Temple, Ranjangaon",
    "description": "The Mahaganapati Temple in Ranjangaon houses one of the most powerful forms of Ganesha, depicted with ten trunks and twenty arms (though this form is hidden and only displayed on special occasions). It is believed that Lord Shiva worshipped this form of Ganesha before battling Tripurasura. The temple’s architecture is grand, with a large stone mandapa and artistic carvings. The idol here symbolizes strength, wisdom, and supreme energy. Pilgrims end their Ashtavinayak yatra at Ranjangaon. Its divine aura makes it an unforgettable experience."
  },
  {
    "title": "Lenyadri Caves",
    "description": "Apart from the Girijatmaj shrine, the Lenyadri Caves themselves are an archaeological marvel. Dating back to the 1st–3rd century AD, these Buddhist caves showcase ancient rock-cut architecture. The caves provide a glimpse into India’s rich cultural past and are surrounded by scenic landscapes. Tourists often explore the caves alongside their temple visit. The combination of history and spirituality makes this site special. It is a must-see for those interested in heritage and architecture."
  },
  {
    "title": "Kukadi River Banks",
    "description": "The Kukadi River flows through Ozar, enhancing the beauty of the Vighneshwar Temple and surrounding areas. Pilgrims often relax by the river after visiting the shrine, enjoying its peaceful flow. The riverbank is also a spot for local festivals and fairs. During monsoon, the area becomes lush and vibrant. It is a place where spirituality meets nature. The Kukadi River adds a refreshing natural charm to the Ashtavinayak pilgrimage circuit."
  }
],


"services": [
    {
        "name": "Pune to Ashtavinayak Innova Tour Package",
        "description": "Experience a comfortable and spiritually fulfilling journey with our Pune to Ashtavinayak Innova tour package. This package covers all eight sacred Ganpati temples with a spacious AC Innova, professional driver, and a well-planned itinerary designed for families and senior citizens seeking both comfort and divine blessings."
    },
    {
        "name": "Ashtavinayak Tour Package Price From Pune",
        "description": "Get transparent pricing for the complete Ashtavinayak tour package starting from Pune. Our all-inclusive rates cover round-trip travel, driver charges, fuel, and waiting time, ensuring a hassle-free pilgrimage. Choose from various car types based on your group size and budget."
    },
    {
        "name": "7 Seater Innova Crysta for Ashtavinayak Darshan",
        "description": "Book a 7-seater Innova Crysta for a smooth and luxurious Ashtavinayak Darshan from Pune. With ample space, AC comfort, reclining seats, and skilled drivers, this vehicle is ideal for group travel and family trips visiting all eight Ganpati temples across Maharashtra."
    },
    {
        "name": "Innova Crysta for Ashtavinayak Tour from Pune",
        "description": "Travel in style and comfort with our Innova Crysta cab for the Ashtavinayak tour from Pune. This service is perfect for those looking to complete the pilgrimage in 1-2 days with a reliable driver, comfortable seating, and enough luggage space for all your needs."
    },
    {
        "name": "Pune to Ashtavinayak Dzire Cab",
        "description": "Hire a Swift Dzire cab from Pune to cover the full Ashtavinayak circuit affordably. Ideal for couples or small families, this AC sedan offers good mileage, smooth rides, and professional drivers who are familiar with the temple routes and local stops."
    },
    {
        "name": "Pune to Ashtavinayak Taxi Service",
        "description": "Enjoy a reliable and professional taxi service for the Ashtavinayak Yatra starting from Pune. We provide clean, well-maintained vehicles, experienced drivers, and the flexibility to customize your route and schedule across all eight holy temples."
    },
    {
        "name": "Pune to Ashtavinayak Round Trip Taxi",
        "description": "Book a round-trip taxi from Pune for a full-day or two-day Ashtavinayak Darshan. With round-trip service, you get one vehicle and driver throughout the tour, including stops for meals and sightseeing, ensuring a smooth and well-paced religious journey."
    },
    {
        "name": "Pune to Ashtavinayak Family Cab",
        "description": "Travel with your entire family in comfort with our family cab service from Pune to Ashtavinayak. Our cabs offer AC, spacious seating, and courteous drivers who help you cover all eight temples safely and comfortably in a single or multi-day trip."
    },
    {
        "name": "Pune to Ashtavinayak Etios Taxi",
        "description": "Opt for a Toyota Etios cab for your Pune to Ashtavinayak trip — a balanced choice for comfort and economy. This sedan provides ample legroom, clean interiors, and AC for a peaceful pilgrimage experience with trusted drivers."
    },
    {
        "name": "Pune to Ashtavinayak Affordable Tour Cab",
        "description": "Looking for a budget-friendly Ashtavinayak tour from Pune? Our affordable tour cabs offer clean vehicles, trained drivers, and well-planned routes to help you complete your Darshan efficiently without compromising on comfort or safety."
    }
],
"tableData": [
    ["Pune to Ashtavinayak Innova Tour Package", "Ashtavinayak Tour Package Price From Pune"],
    ["7 Seater Innova Crysta for Ashtavinayak Darshan", "Innova Crysta for Ashtavinayak Tour from Pune"],
    ["Pune to Ashtavinayak Dzire Cab", "Pune to Ashtavinayak Taxi Service"],
    ["Pune to Ashtavinayak Round Trip Taxi", "Pune to Ashtavinayak Family Cab"],
    ["Pune to Ashtavinayak Etios Taxi", "Pune to Ashtavinayak Affordable Tour Cab"]
],


"whychoose": [
    {
        "WhyChooseheading": "Dedicated Pune to Ashtavinayak Cab Service",
        "WhyChoosedescription": "Prince Cabs offers specialized cab services for the sacred Ashtavinayak Darshan tour from Pune, covering all eight Ganpati temples with comfort, safety, and spiritual focus."
    },
    {
        "WhyChooseheading": "Comfortable Vehicles for Long Pilgrimage Tours",
        "WhyChoosedescription": "Our cabs are spacious, air-conditioned, and well-maintained to ensure a smooth and relaxed journey across all Ashtavinayak temples. Ideal for families, elderly passengers, and group travel."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Knowledge",
        "WhyChoosedescription": "Our drivers are experienced in handling the full Ashtavinayak circuit and are familiar with temple timings, preferred routes, and convenient food/rest stops along the way."
    },
    {
        "WhyChooseheading": "Flexible Packages – One Day or Multi-Day Tours",
        "WhyChoosedescription": "Choose from a one-day express tour or a more relaxed multi-day plan. We offer customizable itineraries tailored to your schedule, temple preferences, and travel comfort."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Vehicles for a Safe Yatra",
        "WhyChoosedescription": "Prince Cabs follows strict hygiene practices. Every cab is cleaned and sanitized before your trip, ensuring a safe and worry-free pilgrimage experience."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "We offer fair and upfront pricing on all Ashtavinayak cab packages. No hidden fees—just reliable service with multiple payment options like UPI, cards, net banking, or cash."
    },
    {
        "WhyChooseheading": "24/7 Support for a Hassle-Free Pilgrimage",
        "WhyChoosedescription": "Our customer support team is available round the clock to assist you with bookings, temple schedules, route queries, or any on-trip concerns, ensuring a smooth and spiritually fulfilling journey."
    }
]




















    }

const faqData = [
    {
        question: 'Does Prince Cabs provide Pune to Ashtavinayak cab services?',
        answer: 'Yes, Prince Cabs offers dedicated cab services for Pune to Ashtavinayak Yatra, covering all eight Ganpati temples with comfort and convenience.',
    },
    {
        question: 'What types of vehicles are available for the Ashtavinayak Yatra from Pune?',
        answer: 'We offer a range of vehicles including hatchbacks, sedans, SUVs, and tempo travellers, ideal for solo travelers, families, or groups.',
    },
    {
        question: 'Is it possible to complete the entire Ashtavinayak Darshan in one trip?',
        answer: 'Yes, we provide full-day and multi-day cab packages to cover all eight temples, with the flexibility to customize your itinerary as per your preference.',
    },
    {
        question: 'Can I choose the order of temple visits during the Ashtavinayak Yatra?',
        answer: 'Absolutely! You can customize the sequence of temple visits, stopovers, and breaks. Our experienced drivers are well-versed with the routes.',
    },
    {
        question: 'What are the charges for the Pune to Ashtavinayak cab service?',
        answer: 'Pricing depends on the vehicle type, number of days, and travel plan. Contact Prince Cabs for a personalized and affordable quote for your Yatra.',
    },
    {
        question: 'How do I book a Pune to Ashtavinayak cab with Prince Cabs?',
        answer: 'Booking is easy—just call us or visit our website with your travel dates and preferences. Our team will assist you in planning your Ashtavinayak Yatra.',
    },
    {
        question: 'Are the cabs clean, safe, and suitable for religious travel?',
        answer: 'Yes, all our vehicles are regularly sanitized, well-maintained, and driven by professional drivers to ensure a safe and spiritual journey.',
    },
];

const testimonials = [
    {
        name: "Mr. Satish Mahajan",
        position: "Religious Trip Organizer",
        text: "We booked a cab from Prince Cabs for the Ashtavinayak Darshan. The driver knew all the temple routes and made our trip very smooth and fulfilling.",
        image: "/img/testimonial/testimonial-thumb-ashtavinayak-1.png",
    },
    {
        name: "Mrs. Kavita Bhonsale",
        position: "Spiritual Traveler",
        text: "Our Pune to Ashtavinayak Yatra with Prince Cabs was very comfortable. The vehicle was clean, and the service was prompt and respectful.",
        image: "/img/testimonial/testimonial-thumb-ashtavinayak-2.png",
    },
];



























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ashtavinayak Cab",
  "image": "https://princecab.com/assets/images/pune-ashtavinayak-cab.jpg",
  "description": "Book Pune to Ashtavinayak cab with Prince Cabs – Comfortable and affordable options for full-day darshan tours. Vehicles include Dzire, Etios, Innova Crysta, and 7-seaters. Ideal for families and groups. 24/7 online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "6820"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5800",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-ashtavinayak-cab"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Ashtavinayak Cab | Innova Tour Packages & Family Cabs | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Ashtavinayak darshan cab packages with affordable pricing and premium vehicles like Innova Crysta, Dzire, and Etios. Book 7-seater family cabs and full-day round trips online, 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Ashtavinayak Innova Tour Package, Ashtavinayak Tour Package Price From Pune, 7 Seater Innova Crysta for Ashtavinayak Darshan, Innova Crysta for Ashtavinayak Tour from Pune, Pune to Ashtavinayak Dzire Cab, Pune to Ashtavinayak Taxi Service, Pune to Ashtavinayak Round Trip Taxi, Pune to Ashtavinayak Family Cab, Pune to Ashtavinayak Etios Taxi, Pune to Ashtavinayak Affordable Tour Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/6.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoashtavinayakcabs;